// Import model
import { AiChat } from '../models/AiChat';

// Import base class serializer
import { EntityOwnedModelSerializer } from './EntityOwnedModelSerializer';

// Import dependency types (models and enums used in properties)
import { AiEmbeddedContent } from '../models/AiEmbeddedContent';

// Import dependency serializers (for complex types)
import { AiEmbeddedContentSerializer } from './AiEmbeddedContentSerializer';

// Import derived type serializers (for polymorphic deserialization)

/**
 * Serializer for AiChat - handles JSON serialization and deserialization with type validation
 */
export class AiChatSerializer {
  /**
   * Deserializes a JSON string into a AiChat instance
   */
  static deserialize(json: string): AiChat {
    const obj = JSON.parse(json);
    return this.fromObject(obj);
  }

  /**
   * Deserializes a plain object into a AiChat instance
   */
  static fromObject(obj: any): AiChat {
    if (!obj) {
      throw new Error('Cannot deserialize null or undefined to AiChat');
    }


    const instance: AiChat = {
      name: obj['name'] as string | undefined,
      description: obj['description'] as string | undefined,
      entityId: obj['entityId'] as string | undefined,
      entityIdName: obj['entityId|Name'] as string | undefined,
      id: obj['_id'] as string | undefined,
      createdDate: obj['createdDate'] as string | undefined,
      flowId: obj['FlowId'] as string | undefined,
      flowIdName: obj['FlowId|Name'] as string | undefined,
      objectStatusId: obj['ObjectStatusId'] as string | undefined,
      objectStatusIdName: obj['ObjectStatusId|Name'] as string | undefined,
      lastMessage: obj['LastMessage'] as any | undefined,
      embeddedContent: obj['EmbeddedContent'] ? AiEmbeddedContentSerializer.fromObject(obj['EmbeddedContent']) : undefined as any,
    };

    return instance;
  }

  /**
   * Deserializes a JSON string into an array of AiChat instances
   */
  static deserializeArray(json: string): AiChat[] {
    const arr = JSON.parse(json);
    if (!Array.isArray(arr)) {
      throw new Error('Expected JSON array');
    }
    return arr.map(obj => this.fromObject(obj));
  }

  /**
   * Serializes a AiChat instance to a JSON string
   */
  static serialize(instance: AiChat): string {
    return JSON.stringify(this.toObject(instance));
  }

  /**
   * Converts a AiChat instance to a plain object
   */
  static toObject(instance: AiChat): any {
    return {
      'name': instance.name,
      'description': instance.description,
      'entityId': instance.entityId,
      'entityId|Name': instance.entityIdName,
      '_id': instance.id,
      'createdDate': instance.createdDate,
      'FlowId': instance.flowId,
      'FlowId|Name': instance.flowIdName,
      'ObjectStatusId': instance.objectStatusId,
      'ObjectStatusId|Name': instance.objectStatusIdName,
      'LastMessage': instance.lastMessage,
      'EmbeddedContent': instance.embeddedContent ? AiEmbeddedContentSerializer.toObject(instance.embeddedContent) : undefined,
    };
  }

  /**
   * Serializes an array of AiChat instances to a JSON string
   */
  static serializeArray(instances: AiChat[]): string {
    return JSON.stringify(instances.map(inst => this.toObject(inst)));
  }
}
